import { Paginated } from '../../../../../core/common/entities/mediahaven-api/paginated.entity';
import { PaginatedResults } from '../entities/paginated-results.entity';
import { PaginationInfo } from '../entities/pagination-info.entity';

export function mapToPaginatedResult<T>(paginated: Paginated<T>, resultsPerPage: number): PaginatedResults<T> {
    const paginationInfo: PaginationInfo = {
        totalNumberOfResults: paginated.TotalNrOfResults,
        page: paginated.StartIndex / Number(resultsPerPage),
        resultsPerPage: Number(resultsPerPage)
    };

    const paginatedResults: PaginatedResults<T> = {
        paginationInfo,
        results: paginated.Results
    };

    return paginatedResults;
}
